// extracted by mini-css-extract-plugin
module.exports = {"gotoLink":"go-to-link-module--gotoLink--1ur2K"};